import React, { useEffect, useMemo } from "react";
import { FormControl, FormLabel } from "react-bootstrap";
import { dealerLogoUrl } from "../../utils/dealerBranding";

const DealerBrandingFields = ({
  logoFile,
  onLogoFileChange,
  existingLogoPath,
  removeBranding,
  onRemoveBrandingChange,
  showRemove,
}) => {
  const objectUrl = useMemo(
    () => (logoFile ? URL.createObjectURL(logoFile) : ""),
    [logoFile]
  );

  useEffect(() => {
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [objectUrl]);

  const previewUrl = objectUrl || dealerLogoUrl(existingLogoPath);

  return (
    <>
      <div>
        <FormLabel>Dashboard logo</FormLabel>
        <FormControl
          key={removeBranding ? "removed" : logoFile ? "chosen" : "empty"}
          type="file"
          accept="image/png,image/jpeg,image/webp,image/gif"
          onChange={(e) => onLogoFileChange(e.target.files?.[0] || null)}
          disabled={removeBranding}
        />
      </div>

      <div className="dealer-branding-note">
        <p>
          Optional. Shown on the user dashboard next to the customer's company
          name.
        </p>
        {previewUrl && !removeBranding && (
          <img
            src={previewUrl}
            alt=""
            className="dealer-branding-preview"
          />
        )}
        {showRemove && (
          <label className="dealer-branding-remove">
            <input
              type="checkbox"
              checked={removeBranding}
              onChange={(e) => onRemoveBrandingChange(e.target.checked)}
            />
            Remove branding
          </label>
        )}
      </div>
    </>
  );
};

export default DealerBrandingFields;
